import React from "react";
import { HeartHandshake } from "lucide-react";

const ABOUT_IMAGE =
  "https://images.unsplash.com/photo-1683109944202-e74e2adbc8cf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHw0fHxzdGFydHVwJTIwdGVhbSUyMHdvcmtpbmclMjBkaXZlcnNlfGVufDB8fHx8MTc3NzM2MTYzNnww&ixlib=rb-4.1.0&q=85";

export default function About() {
  return (
    <section id="about" className="py-20 md:py-28 bg-brand-surfaceAlt" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <div className="relative rounded-3xl overflow-hidden border border-brand-border shadow-md">
            <img
              src={ABOUT_IMAGE}
              alt="Career Connect consultants at work"
              className="w-full h-[420px] object-cover"
              data-testid="about-image"
              loading="lazy"
            />
          </div>
        </div>

        <div className="lg:col-span-7 order-1 lg:order-2">
          <span className="uppercase text-xs tracking-[0.22em] font-bold text-brand-primary">
            About Career Connect
          </span>
          <h2 className="mt-3 font-heading font-medium text-3xl sm:text-4xl lg:text-5xl tracking-tight">
            A people-first HR partner —
            <br className="hidden sm:block" /> built for modern workplaces.
          </h2>
          <p className="mt-6 text-brand-muted leading-relaxed">
            Founded in <strong>2026</strong> by <strong>Priyanka Khasnis</strong>, Career
            Connect is based in Parvati, Pune and works with companies across India. We
            blend recruitment expertise with a human, empathetic approach — partnering
            closely with founders and hiring managers to understand the role, the culture
            and the long game, so every placement is one that sticks.
          </p>
          <p className="mt-4 text-brand-muted leading-relaxed">
            For candidates, we’re in your corner. From stronger CVs to mock interviews
            and clear career guidance, we help you show up confident, prepared and ready.
          </p>

          <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
            <div className="rounded-xl bg-white border border-brand-border px-4 py-3" data-testid="about-founder">
              <div className="text-[11px] uppercase tracking-[0.18em] text-brand-muted font-semibold">
                Founder
              </div>
              <div className="mt-1 font-medium text-brand-ink">Priyanka Khasnis</div>
            </div>
            <div className="rounded-xl bg-white border border-brand-border px-4 py-3" data-testid="about-founded">
              <div className="text-[11px] uppercase tracking-[0.18em] text-brand-muted font-semibold">
                Founded
              </div>
              <div className="mt-1 font-medium text-brand-ink">2026 · Parvati, Pune</div>
            </div>
          </div>

          <div className="mt-8 inline-flex items-center gap-3 bg-white border border-brand-border rounded-2xl px-5 py-4 shadow-sm">
            <div className="w-10 h-10 rounded-xl bg-brand-soft grid place-items-center text-brand-primary">
              <HeartHandshake size={20} />
            </div>
            <p className="text-sm text-brand-ink font-medium">
              We don’t just fill roles — we help build strong teams and meaningful careers.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
